import React from 'react';
import {
  Card, ComponentVerticalSpacing, ComponentWrapper
} from 'day8-react/build/new-components';
import PropTypes from 'prop-types';

const Intro = props => {
  const { intro } = props;
  return (
    <div className="tsw-c-crew-finder-intro position-relative margin-bottom-xl">
      <div className="text-center">
        <div className="intro-bg d8-u-bg-img width-100% position-absolute" style={{ backgroundImage: `url(${intro.bgimage})`, height: '60%' }} />
        <div className="padding-top-xl">
          <ComponentWrapper>
            <h2 className="text-center margin-bottom-md max-width-xxxxs margin-auto position-relative d8-u-color-white">
              {intro.title}
            </h2>
            <div className="max-width-sm margin-auto">
              <div className="d8-c-crewfinder-intro-grid">
                {intro.images.map((image, i) => (
                  <span key={image.image.id} className={`${i !== 1 && 'display@sm'} position-relative d8-u-zindex-header`}>
                    <img className="d8-u-radius-md" src={image.image.url} alt={image.image.alt} />
                  </span>
                ))}
              </div>
              {intro.text && <div className="intro-text max-width-xxxs margin-auto text-center margin-top-md"><p>{intro.text}</p></div>}
            </div>
          </ComponentWrapper>
        </div>
      </div>
    </div>
  );
};


Intro.propTypes = {
  intro: PropTypes.object
};

export default Intro;
